import { ClientTypes } from "../../store/orgId_context";

export const menuContent = [
  {
    itemName: "Company profile",
    url: "/my-profile",
    roles : ["integrator", "transformer", ClientTypes.AccService, ClientTypes.ISV, "all"],
  },
  {
    itemName: "My profile",
    url: "/user-settings",
    roles : ["all"],
  },
  /*{
    itemName: "Edit my invoices",
    url: "/edit-invoices",
    roles : ["integrator", "transformer"],
  },*/
  {
    itemName: "Team members",
    url: "/add-user",
    roles : ["integrator", "transformer", ClientTypes.AccService, ClientTypes.ISV, "all"],
  },
  /*{
    itemName: "API keys & credentials",
    url: "/api-keys-and-credentials",
    roles : ["integrator", "transformer"],
  },*/
  {
    itemName: "Payments & billing",
    url: "/change-payment-plan",
    roles : ["integrator", "transformer", ClientTypes.AccService, ClientTypes.ISV, ClientTypes.Company],
  },
  /* {
    itemName: "Customer relations",
    url: "/customer-relations",
    roles : ["integrator", "transformer", ClientTypes.ISV],
  },
  {
    itemName: "Packages",
    url: "/packages",
    roles : ["integrator", "transformer", ClientTypes.AccService, ClientTypes.ISV],
  },
  {
    itemName: "Billing",
    url: "/billing",
    roles : ["integrator", "transformer", ClientTypes.AccService, ClientTypes.ISV],
  }, */
];
